import { render, staticRenderFns } from "./advancedScreening.vue?vue&type=template&id=4815e616&scoped=true&"
import script from "./advancedScreening.vue?vue&type=script&lang=js&"
export * from "./advancedScreening.vue?vue&type=script&lang=js&"
import style0 from "./advancedScreening.vue?vue&type=style&index=0&id=4815e616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4815e616",
  null
  
)

export default component.exports